import { OrderResponseItem } from '../../data/models'
import { formatQuantity } from '../../utils/formatUtils'
import i18n from '../../utils/i18n'

export const NumberBodyTemplate = (
  quantity?: number | null,
  confirmationCode?: OrderResponseItem['ConfirmationCode'],
) => {
  if (quantity === null || quantity === undefined) return null

  const { language } = i18n

  // If the item was rejected show no quantity
  if (confirmationCode === 'REJECTED') {
    return <></>
  }

  // Otherwise show a formatted quantity
  return <>{formatQuantity(quantity, undefined, language)}</>
}
